import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import {
  diaChiSearchColumns,
  phuongThucGiaoHangSearchColumns,
  phuongThucThanhToanSearchColumns,
  phuongThucVanChuyenSearchColumns,
  QUERY_KEYS
} from '@/constants';
import { DiaChi, PhuongThucGiaoHang, PhuongThucThanhToan, PhuongTienVanChuyen } from '@/types/schemas';
import { FormFieldV2, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { useDonHangSearchContext } from '../../context';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export function OtherTab({ formMode, formState: { state, actions } }: OtherTabProps) {
  const { transactionOptions } = useDonHangSearchContext();
  const defaultMaGD = transactionOptions[0]?.value || 'NB';
  const { watch, setValue } = useFormContext();
  const maGD = watch('ma_gd');

  useEffect(() => {
    if (maGD || !defaultMaGD) return;

    setValue('ma_gd', defaultMaGD, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: true
    });
  }, [defaultMaGD, maGD, setValue]);

  const rowClassName = 'flex items-center gap-2 xl:gap-3';
  const labelClassName = 'w-28 shrink-0 text-[13px] xl:w-32 2xl:w-36';

  return (
    <div className='space-y-2 p-3 xl:p-4'>
      <div className={rowClassName}>
        <Label className={labelClassName}>Địa chỉ giao hàng</Label>
        <SearchField<DiaChi>
          type='text'
          value={state.diaChi?.ma_dc || ''}
          relatedFieldValue={state.diaChi?.ten_dc || ''}
          searchEndpoint={`/${QUERY_KEYS.DIA_CHI}/`}
          searchColumns={diaChiSearchColumns}
          columnDisplay='ma_dc'
          displayRelatedField='ten_dc'
          dialogTitle='Danh mục địa chỉ giao hàng'
          onRowSelection={actions.setDiaChi}
          disabled={formMode === 'view'}
          className='w-100'
        />
      </div>

      <div className={rowClassName}>
        <Label className={labelClassName}>Phương tiện v/c</Label>
        <SearchField<PhuongTienVanChuyen>
          type='text'
          value={state.phuongTienVanChuyen?.ma_ptvc || ''}
          relatedFieldValue={state.phuongTienVanChuyen?.ten_ptvc || ''}
          searchEndpoint={`/${QUERY_KEYS.PHUONG_TIEN_VAN_CHUYEN}/`}
          searchColumns={phuongThucVanChuyenSearchColumns}
          columnDisplay='ma_ptvc'
          displayRelatedField='ten_ptvc'
          dialogTitle='Danh mục phương tiện vận chuyển'
          onRowSelection={actions.setPhuongTienVanChuyen}
          disabled={formMode === 'view'}
          className='w-100'
        />
      </div>

      <div className={rowClassName}>
        <Label className={labelClassName}>Ph/th thanh toán</Label>
        <SearchField<PhuongThucThanhToan>
          type='text'
          value={state.phuongThucThanhToan?.ma_pttt || ''}
          relatedFieldValue={state.phuongThucThanhToan?.ten_pttt || ''}
          searchEndpoint={`/${QUERY_KEYS.PHUONG_THUC_THANH_TOAN}/`}
          searchColumns={phuongThucThanhToanSearchColumns}
          columnDisplay='ma_pttt'
          displayRelatedField='ten_pttt'
          dialogTitle='Danh mục phương thức thanh toán'
          onRowSelection={actions.setPhuongThucThanhToan}
          disabled={formMode === 'view'}
          className='w-100'
        />
      </div>

      <div className={rowClassName}>
        <Label className={labelClassName}>Ph/th giao hàng</Label>
        <SearchField<PhuongThucGiaoHang>
          type='text'
          value={state.phuongTienGiaoHang?.ma_ptgh || ''}
          relatedFieldValue={state.phuongTienGiaoHang?.ten_ptgh || ''}
          searchEndpoint={`/${QUERY_KEYS.PHUONG_THUC_GIAO_HANG}/`}
          searchColumns={phuongThucGiaoHangSearchColumns}
          columnDisplay='ma_ptgh'
          displayRelatedField='ten_ptgh'
          dialogTitle='Danh mục phương thức giao hàng'
          onRowSelection={actions.setPhuongTienGiaoHang}
          disabled={formMode === 'view'}
          className='w-100'
        />
      </div>

      <div className={rowClassName}>
        <Label className={labelClassName}>Giao dịch</Label>
        <div className='w-[156px] xl:w-[168px] 2xl:w-[200px]'>
          <FormFieldV2
            name='ma_gd'
            className='w-full'
            type='select'
            disabled={formMode === 'view'}
            options={transactionOptions}
          />
        </div>
      </div>

      <div className={rowClassName}>
        <Label className={labelClassName}>Treo đơn hàng</Label>
        <div className='w-full'>
          <FormFieldV2 name='treo_dh' type='text' disabled={true} placeholder='Không treo' />
        </div>
      </div>
    </div>
  );
}
